import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './FinishLaterButton.css';

const FinishLaterButton = ({hasDraft, isLoading, onClick, onMouseDown}) => {
    return (
        <div className={s.component}>
            <nav className={s.container}>
                <button
                    type="button"
                    className={cx(s.iconButton)}
                    disabled={!hasDraft || isLoading}
                    onMouseDown={onMouseDown}
                    onClick={onClick}
                >
                FINISH LATER
                </button>
            </nav>
        </div>
    );
};

FinishLaterButton.propTypes = {
    hasDraft: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
    onMouseDown: PropTypes.func,
};

export default FinishLaterButton;


// WEBPACK FOOTER //
// ./src/components/Pages/Forms/PrivateForms/FormButtons/FinishLaterButton/FinishLaterButton.js